export const Access = (permissions: string[] | undefined) => {
  return {
    canEditUser: () => {
      return (
        permissions?.includes('user-admin-edit') ||
        permissions?.includes('super-admin')
      );
    },
    canEditSettings: () => {
      return (
        permissions?.includes('super-admin') ||
        permissions?.includes('rewards-super-admin')
      );
    },
    canEditState: () => {
      return (
        permissions?.includes('super-admin') ||
        permissions?.includes('rewards-super-admin')
      );
    },
  };
};
